var chunkToChildrenMap = {
	"1593": [
		7343,
		9320,
		6834
	],
	"2831": [
		3387
	],
	"3147": [
		3387
	],
	"5839": [
		8240
	],
	"6254": [
		3387
	],
	"7552": [
		7343,
		6101,
		4843,
		4999,
		9985,
		4829,
		5839,
		1013,
		9838,
		6183
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));